import { Link } from 'react-router-dom';
import { Box, CircularProgress, styled, Typography } from '@mui/material';
import { SelectInput } from 'components/Select';
import Background from 'images/background.svg';
import Mobilebackground from 'images/background-mobile.svg';
import { ReactComponent as Logo } from 'images/av-logo-vertical.svg';

export const PageWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  background: `url(${Background})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  width: '100vw',
  height: '100vh',
  [theme.breakpoints.down('sm')]: {
    background: `url(${Mobilebackground})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
}));

export const AcmeLogo = styled(Logo)({
  width: '102px',
  height: '70px',
});

export const Container = styled('div')(({ theme }) => ({
  width: '375px',
  backgroundColor: theme.palette.primary.white,
  boxShadow: '0px 0px 30px rgba(0, 84, 135, 0.05)',
  borderRadius: '8px',
  padding: '40px 40px',
  boxSizing: 'border-box',
  [theme.breakpoints.down('sm')]: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderRadius: '0px',
  },
}));

export const TitleContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: '5px',
}));

export const Row = styled('div')(({ marginBottom }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  marginBottom: marginBottom || '20px',
}));

export const ButtonContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  paddingTop: 20,
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.gray100,
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '24px',
  lineHeight: '140%',
  textAlign: 'center',
}));

export const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.gray75,
  fontSize: '13px',
  marginBottom: '20px',
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: '600',
  textDecoration: 'none',
  marginTop: '27px',
  color: theme.palette.primary.fuchsia75,
}));

export const Select = styled(SelectInput)(({ theme }) => ({
  '& .MuiInputBase-root': {
    borderRadius: '8px',
    opacity: 1,
    borderColor: theme.palette.primary.gray15,
    '&: hover': {
      borderColor: theme.palette.primary.gray50,
    },
  },
}));

export const Loader = () => (
  <Box
    display='flex'
    justifyContent='center'
    alignItems='center'
    height='200px'
  >
    <CircularProgress />
  </Box>
);
